<template>
  <div class="columns is-centered mt-5">
    <div class="column is-half-tablet">
      <div class="box">
        <h1 class="title mb-0">Reset Password</h1>
        <div v-if="!showSuccess">
          <p class="subtitle">Enter your email to reset your password</p>
          <form @submit.prevent>
            <b-input v-model.trim="email" id="email" placeholder="Email" autocomplete="email"></b-input>
          </form>
          <p v-if="errorMsg !== ''" class="error">{{ errorMsg }}</p>
          <button @click="resetPassword()" class="button is-primary">Reset</button>
        </div>
        <p v-else> <b-icon pack="fas" icon="success" size="is-medium"></b-icon>  Success! Check your email for a reset link.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";

export default {
  data() {
    return {
      email: "",
      showSuccess: false,
      errorMsg: ""
    };
  },
  methods: {
    async resetPassword() {
      this.errorMsg = "";

      try {
        await auth.sendPasswordResetEmail(this.email);
        this.showSuccess = true;
      } catch (err) {
        this.errorMsg = err.message;
      }
    }
  }
};
</script>